import { connect } from 'react-redux';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import ProfileBackground from 'profile/components/profile_background';

export default connect(mapProfileToProps)(ProfileBackground);



// WEBPACK FOOTER //
// ./profile/containers/profile_background.js